import { ThemeProvider } from "@emotion/react";
import { withStyles } from "@material-ui/core/styles";
import ArrowBackIos from "@mui/icons-material/ArrowBackIos";
import NearMeOutlined from "@mui/icons-material/NearMeOutlined";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import IconButton from "@mui/material/IconButton";
import { createTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import { makeStyles } from "@mui/styles";
// import NormalButton from "components/atoms/Button/NormalButton";
import { NotificationContext } from "context";
import * as React from "react";
import { useContext } from "react";
import { useNavigate } from "react-router-dom";

const colortheme = createTheme({
  palette: {
    primary: {
      main: "#292739",
    },
    secondary: {
      main: "#c1c1c1",
    },
  },
  typography: {
    fontFamily: ["lato"].join(","),
  },
});

// const tabButtonStyles = {
//   padding: ".5rem 1rem",
//   borderRadius: "50px",
// }

const useStyles = makeStyles((theme) => ({
  notificationText: {
    fontSize: "23px",
  },
}));

const NotificationText = withStyles({
  root: {
    color: "#ffffff",
    fontSize: "23px",
  },
})(Typography);

// type ContentType = {
//   all: boolean;
//   like: boolean;
//   dms: boolean;
//   com: boolean;
// };

const Header = () => {
  const classes = useStyles();
  const history = useNavigate();
  // const [contentPage, setContentPage] = React.useState<ContentType>({
  //   all: true,
  //   like: false,
  //   dms: false,
  //   com: false,
  // });
  const { originalPage } = useContext(NotificationContext);

  // const clickAll = (): void => {
  //   setContentPage({ all: true, like: false, dms: false, com: false });
  // };
  // const clickLike = (): void => {
  //   setContentPage({ all: false, like: true, dms: false, com: false });
  // };
  // const clickDms = (): void => {
  //   setContentPage({ all: false, like: false, dms: true, com: false });
  // };
  // const clickCom = (): void => {
  //   setContentPage({ all: false, like: false, dms: false, com: true });
  // };
  return (
    <React.Fragment>
      <ThemeProvider theme={colortheme}>
        <AppBar
          position="relative"
          color="primary"
          sx={{
            top: 0,
            // height: "120px",
            // paddingTop: "73px",
            padding: "2rem 1rem",
            boxShadow: "none",
          }}
        >
          <Box
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              backgroundColor: "#292739",
            }}
          >
            <Box display="flex" sx={{ alignItems: "center" }}>
              <div onClick={() => history("/" + originalPage)}>
                <ArrowBackIos />
              </div>
              <NotificationText className={classes.notificationText}>
                Notifications
              </NotificationText>
            </Box>
            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="secondary"
              sx={{ padding: "unset" }}
            >
              <div onClick={() => history("/message")}>
                <NearMeOutlined style={{ height: "30px", width: "30px" }} />
              </div>
            </IconButton>
          </Box>
        </AppBar>
        {/* <Box
          position="relative"
          sx={{
            zIndex: "100",
            height: "39px",
            display: "flex",
            paddingLeft: "38px",
            paddingY: "20px",
            backgroundColor: "#292739",
            gap: "10px",
          }}
        >
          <div onClick={() => clickAll()}>
            <NormalButton
              text={"All"}
              color={"yellow"}
              isClicked={contentPage.all}
              style={tabButtonStyles}
            />
          </div>
          <div onClick={() => clickLike()}>
            <NormalButton
              text={"Likes"}
              color={"yellow"}
              isClicked={contentPage.like}
              style={tabButtonStyles}
            />
          </div>
          <div onClick={() => clickDms()}>
            <NormalButton
              text={"DMs"}
              color={"yellow"}
              isClicked={contentPage.dms}
              style={tabButtonStyles}
            />
          </div>
          <div onClick={() => clickCom()}>
            <NormalButton
              text={"Comments"}
              color={"yellow"}
              isClicked={contentPage.com}
              style={tabButtonStyles}
            />
          </div>
        </Box> */}
      </ThemeProvider>
    </React.Fragment>
  );
};

export default Header;
